/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React from "react";

type MoreInfoIconProps = {
  displayName?: string;
  muiName?: string;
} & SvgIconProps;

const MoreInfoIcon = ({ displayName = "MoreInfo", muiName = "SvgIcon", ...rest }: MoreInfoIconProps) => {
  return (
    <SvgIcon viewBox={"0 0 256 256"} {...rest}>
      <path
        d="M177.4,24.1c-27.5-4.1-55.8,5.3-75.7,25c-2,1.9-2,5.1,0,7c1.9,1.9,5.1,2,7,0c17.7-17.5,42.8-25.8,67.3-22.2
		c40,5.9,69.1,40.7,67.8,81c-0.1,3.1-0.3,53.9-0.5,103.1v4.1l-49.5-36l-2.5,0.9c-13.3,4.8-27.7,5.9-41.7,3.2
		c-20.9-4-39-16.1-50.9-33.9c-1.5-2.3-4.6-2.9-6.9-1.4s-2.9,4.6-1.4,6.9c13.4,20,33.7,33.6,57.3,38.1c14.9,2.9,30.2,1.9,44.4-2.7
		l46.5,33.8c1.6,1.1,3.5,1.7,5.4,1.7c1.4,0,2.9-0.3,4.2-1c3.1-1.6,5-4.7,5-8.1v-5.5c0.1-29.8,0.4-99.5,0.5-102.9
		C255.2,69.9,222.4,30.7,177.4,24.1z"
      />
      <path
        d="M48,212.7c-4.1,0-7.5,3.4-7.5,7.6c0,4.1,3.4,7.6,7.5,7.6c2.2,0,4.1-0.8,5.5-2.3c1.4-1.4,2.2-3.4,2.1-5.5
		C55.6,215.9,52.3,212.7,48,212.7z"
      />
      <path
        d="M100.3,80.1C91.9,64,73.5,53.6,53.4,53.6c-22.7,0-41.7,12.7-50.8,34c-1.1,2.5,0.1,5.4,2.6,6.5s5.4-0.1,6.5-2.6
		c7.5-17.5,23-28,41.6-28c16.5,0,31.4,8.3,38,21.1c4.3,8.6,7,22.3-5,38.8c-6,8.3-13.8,14-20.1,18.7c-8.2,6-14.3,10.9-17.5,18
		c-3.3,7.1-4.8,17.2-4.9,31.6c0,2.7,2.2,5,4.9,5l0,0c2.7,0,4.9-2.2,5-4.9c0.1-13,1.4-21.7,4.1-27.6c2.2-4.9,7.1-8.7,14.4-14.1
		c6.8-5,15.3-11.3,22.2-20.7C110.2,107.6,104.9,89.2,100.3,80.1z"
      />
    </SvgIcon>
  );
};

export default MoreInfoIcon;
